import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventFeatureFlags } from '@shared/hooks/useEventFeatureFlags/useEventFeatureFlags';
import { useEventInfo } from '@shared/utils/eventInfo';

type useWebsiteDesignerV3FeatureReturnType = Readonly<{
  value: boolean;
  isLoading: boolean;
}>;

export const useWebsiteDesignerV3Feature = (): useWebsiteDesignerV3FeatureReturnType => {
  const { eventHandle } = useEventInfo();

  const eventFeatureFlags = useEventFeatureFlags({ eventHandle: eventHandle || '', skip: !eventHandle });
  const isEventEligible = !eventFeatureFlags.loadingEventFeatureFlags && eventFeatureFlags.isEventFeatureFlagEnabled('useWebsiteDesignerV3');

  const [isEnabled, isLoading] = useIsFeatureEnabled('websiteDesignerV3Enabled', {
    skip: !isEventEligible,
  });

  const eventExposure = useMemo(
    () => ({
      value: isEnabled,
      isLoading,
    }),
    [isEnabled, isLoading],
  );

  return eventExposure;
};
